module.exports = __webpack_public_path__ + "static/floralplaysuit-4c48b135c94ac415952499e2b99455de.jpeg";